import { createI18n, LocaleMessages, VueMessageType } from "vue-i18n";
import Cookies from "js-cookie";

/**
 * Load locale messages
 *
 * The loaded `JSON` locale messages is pre-compiled by `@intlify/vue-i18n-loader`, which is integrated into `vue-cli-plugin-i18n`.
 * See: https://github.com/intlify/vue-i18n-loader#rocket-i18n-resource-pre-compilation
 */
function loadLocaleMessages(): LocaleMessages<VueMessageType> {
  console.log(navigator.language, "navigator.language");

  const locales = require.context("./locales", true, /[A-Za-z0-9-_,\s]+\.json$/i);
  console.log(locales.keys(), "locales.keys()");
  const messages: LocaleMessages<VueMessageType> = {};
  locales.keys().forEach((key) => {
    const matched = key.match(/([A-Za-z0-9-_]+)\./i);
    console.log(matched, "matched");
    if (matched && matched.length > 1) {
      const locale = matched[1];
      messages[locale] = locales(key).default;
    }
  });

  console.log(messages, "<=messages");
  return messages;
}

const messages = loadLocaleMessages();

const cookieLocale = Cookies.get("user-locale") ?? "";
let locale = cookieLocale || navigator.language || process.env.VUE_APP_I18N_LOCALE || "en";
// 'ko-KR' 처럼 지역 코드가 붙은 경우, 메시지 파일(ko.json 등)에 맞게 언어 코드만 사용
if (!messages[locale] && locale.indexOf("-") > 0) {
  locale = locale.substring(0, locale.indexOf("-"));
}
console.log(locale, "locale");

export default createI18n({
  legacy: false,
  locale: locale,
  fallbackLocale: process.env.VUE_APP_I18N_FALLBACK_LOCALE || "en",
  messages,
});
